import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import { Grid } from '@material-ui/core';
import './styles.css';
import { CommonConfig } from '../../../config/common-config';
import FinalImage from '../../../assets/downimage.png';
import TabList from '../../../components/checklistTab/tabList';

const useStyles = makeStyles((theme) => ({
    root: {
        boxShadow: '0px 5px 10px #efefef !important',
        borderRadius: '8px',
        minHeight: '300px',
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        color: '#727272',
        fontSize: '20px',
        fontFamily: 'Rubik',
        fontWeight: '500',
        marginBottom: '20px',
    },
    pos: {
        marginBottom: 12,
    },
    rootCard: {
        marginBottom: '20px',
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    bottomLine: {
        padding: '0',
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '10px 0',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    inlineDisplayFont: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '0px 20px',
            color: '#7779ba',
            marginTop: '-10px',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
        margin: '0 10px !important',
        minWidth: '200px',
        fontFamily: 'Rubik !important',
    },
    inlinebutton: {
        padding: '0',
        margin: '0',
        '& li': {
            listStyle: 'none',
            display: 'inline-block',
            marginRight: '15px',
        },
    },
}));

export default function ClientFinalDocApproval() {
    const classes = useStyles();
    const [state, setState] = React.useState({
        checkedA: true,
    });
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const serviceIdValue = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const tennantName = tennantDetails && tennantDetails.tennantName;
    // const tennantName = useSelector((state) => state.serviceCheckListReducer.imcNameSelected);
    const [finaldraft, setFinalDraft] = useState({});

    useEffect(() => {
        axios
            .get(`${CommonConfig.dev.baseUrl1}/api/itr/final-computation/by-serviceId/${tennantName}/${serviceIdValue}`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                setFinalDraft(response.data);
            })
            .catch((error) => {
                //console.log(error);
            });
    }, []);

    const downloadFile = () => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/mergedpdffile/${serviceIdValue}/${tennantName}`, {
                headers: {
                    Authorization: bearerToken,
                },
                responseType: 'blob',
            })

            .then((response) => {
                const link = document.createElement('a');
                ////console.log('link480', link);

                link.href = response.config.url;
                link.setAttribute('download', response.config.url);

                // Start download
                link.click();
            });
    };

    return (
        <div>
            {/* <div className="stage-indicator">
                <ul>
                    <li>L1 Checklist</li>
                    <li>L1 CRC Confirmed</li>
                    <li>Detailed Analysis</li>
                    <li>Draft Statements</li>
                    <li >Tax Payment and Filing</li>
                </ul>
            </div> */}
            <TabList />
            <Formik enableReinitialize>
                {(formik) => {
                    return (
                        <form className="itecform">
                            <Card className={classes.root}>
                                <CardContent>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} sm={12} className="main-container">
                                            {/* <Typography className="final-doc-title">Tax payment client approved</Typography> */}
                                        </Grid>
                                        <Grid item xs={12} sm={12} className="text-center">
                                            <img src={FinalImage} alt="final-img" />
                                        </Grid>
                                        <Grid item xs={12} sm={12} className="text-center">
                                            <FormControl fullWidth className="mt50 mb50 btn-center">
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    size="small"
                                                    className={classes.button}
                                                    onClick={downloadFile}
                                                >
                                                    {/* Download final computation document */}
                                                    {/* Download Tax Payment Document */}
                                                    Download ITR Final Documents
                                                </Button>
                                                {/* <Button variant="outlined" color="primary" size="small" className={classes.button}>
                                                    Download Tax payment document
                                            </Button>
                                                <Button variant="outlined" color="primary" size="small" className={classes.button}>
                                                    Download TAX Challan
                                            </Button>
                                                <Button variant="outlined" color="primary" size="small" className={classes.button}>
                                                    ITR Acknowledgement
                                            </Button> */}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
}
